import { useState, useEffect } from 'react';
import '../style.scss'

interface RangeSelectPopUpProps {
	label: string
	valueLabels: string[]
	currentValueIndexes?: number[]
	onValueSelected?: (selectedValues: number[] | undefined) => void
}

function RangeSelectPopUp({label, valueLabels, currentValueIndexes, onValueSelected}: RangeSelectPopUpProps ) {
	const [rangeSelection, setRangeSelection] = useState<number[] | undefined>(currentValueIndexes)

	useEffect(() => {
		setRangeSelection(currentValueIndexes)
	}, [currentValueIndexes])

	const valueIndicatorClicked = (index: number) => {
		console.log('valueIndicatorClicked, rangeSelection =', rangeSelection)
		if (!rangeSelection) {
			setRangeSelection([index])
		} else if (rangeSelection.length === 1) {
			let newArr: number[] = []
			if (rangeSelection[0] === index) {
				setRangeSelection(undefined)
				if (onValueSelected) {
					onValueSelected(undefined)
				}
			} else if (rangeSelection[0] < index) {
				newArr.push(rangeSelection[0])
				newArr.push(index)
				setRangeSelection(newArr)
				if (onValueSelected) {
					onValueSelected(newArr)
				}
			} else {
				newArr.push(index)
				newArr.push(rangeSelection[0])
				setRangeSelection(newArr)
				if (onValueSelected) {
					onValueSelected(newArr)
				}
			}
		} else {
			setRangeSelection([index])
			// if (onValueSelected) {
			// 	onValueSelected([index])
			// }
		}
	}

	return (
		<div className='select-pop-up-wrap'>
			<div className="select-pop-up-label">
				{label}
			</div>
			<div className='select-pop-up-value-label-wrap'>
				{valueLabels.map((value: string, index) => 
					<div className='select-pop-up-value-label' key={`selectValueLabel${index}`}>{value}</div>
				)}
			</div>
			<div className='select-pop-up-value-indicator-wrap'>
				{valueLabels.map((label, index) => 
					<div 
						className={`select-pop-up-value-indicator ${rangeSelection?.includes(index) ? 'selected' : ''}`}
						key={`select-value-indicator-${label}${index}`}
						onClick={() => valueIndicatorClicked(index)}
					/>
				)}
			</div>
		</div>
	)
}

export default RangeSelectPopUp